<template>
  <el-dialog title="关联用户" :visible.sync="dialogInfo.flag" v-if="dialogInfo.flag" width="550px"
    :close-on-click-modal="false">
    <el-form class="form" size="small" label-position="right" label-width="100px" :rules="rules" :model="linkForm"
      ref="linkForm">
      <el-form-item label="用户ID：">
        <div>{{ userInfo.userId || '' }}</div>
      </el-form-item>
      <el-form-item label="关联用户：" prop="selectUserName">
        <load-select style="width: 100%" v-model="linkForm.selectUserId" dictLabel="userName" dictValue="uuid"
          :data="userList" :page="page" :hasMore="more" :request="getLinkSelectPage" @ChangeValue="changeSelectUser"
          :isInit="isInit" :defaultVal="linkForm.selectUserName" placeholder="请输入姓名/手机号" />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="closeDia" title="取消"></butn>
      <butn btntype="primary" @click.native="sureSubmit" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import LoadSelect from "@/components/load-select/index.vue";
import { linkSelectToUser, linkSelectPage } from "@/api/user.js";
export default {
  components: { butn, LoadSelect },
  props: {
    dialogInfo: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      linkForm: {
        selectUserName: "",
      },
      rules: {
        selectUserName: [
          { required: true, message: '请选择关联用户', trigger: "change" },
        ],
      },
      userInfo: {},

      isInit: true,
      userList: [],
      page: 1,
      more: true,
      
    };
  },
  created() {
    this.userInfo = this.dialogInfo.row || {};
  },
  methods: {

    changeSelectUser(val) {      
      if (!!val) {
        let item = this.userList.filter(x => x.uuid == val)[0];
        this.linkForm.selectUserName = item.userName;
        this.linkForm.selectUserId = item.uuid
      } else {
        this.linkForm.selectUserName = "";
        this.linkForm.selectUserId = "";
      }
    },

    getLinkSelectPage({ page = 1, more = false, keyword = "" } = {}) {
      return new Promise((resolve, reject) => {
        linkSelectPage({
          page,
          userCheckId: this.userInfo.userCheckId,
          userName: keyword,
        }).then(({ code, data }) => {
          this.dealClass(more, code, data);
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },

    dealClass(more, code, data) {
      if (code !== 0) return;
      if (more) {
        this.userList = [...this.userList, ...data.records];
      } else {
        this.userList = data.records;
      }
      this.page = data.current;
      let { current, total, size } = data;
      this.more = current * size < total;
      this.page = current;
    },

    closeDia() {
      this.$emit("closeDialog", false);
    },
    sureSubmit() {
      this.$refs.linkForm.validate(valid => {
        if (valid) {
          let params = {
            uuid: this.userInfo.uuid,
            selectUserId: this.linkForm.selectUserId,
          };
          linkSelectToUser(params).then((res) => {
            if (!res || res.code != 0) return;
            this.$emit("closeDialog", true);
          });
        }
      });
    },
  },
};
</script>

<style></style>
